import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Tooltip from '@material-ui/core/Tooltip';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TableBody from '@material-ui/core/TableBody';
import TableFooter from '@material-ui/core/TableFooter';

const columnData = [
    { id: 'date', numeric: false, disablePadding: true, label: 'Date' },
    { id: 'paid', numeric: true, disablePadding: false, label: 'Paid' },
    { id: 'order_subtotal', numeric: true, disablePadding: false, label: 'Order Subtotal' },
    { id: 'tax', numeric: true, disablePadding: false, label: 'Tax' },
    { id: 'tip', numeric: true, disablePadding: false, label: 'Tip' },
    { id: 'total', numeric: true, disablePadding: false, label: 'Total' },
    { id: 'promo_discount', numeric: true, disablePadding: false, label: 'Promo Discount' },
    { id: 'member_fees', numeric: true, disablePadding: false, label: 'Member Fees' },
    { id: 'member_discount', numeric: true, disablePadding: false, label: 'Members Discount' },
    { id: 'fee', numeric: true, disablePadding: false, label: 'Fee' },
    { id: 'rewards', numeric: true, disablePadding: false, label: 'Rewards Value' },
];

class DataTableHead extends Component {

    render() {

        return (
            <TableHead>
                <TableRow>
                    {columnData.map(column => {
                        return (
                            <TableCell
                                key={column.id}
                                numeric={column.numeric}
                                padding={column.disablePadding ? 'none' : 'default'}
                            >
                                <Tooltip
                                    title="Sort"
                                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={false}
                                        direction={'asc'}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}


class LoadingTable extends Component {
    render() {
        return (
            <div className="table-responsive-material" style={{ marginRight: 10, marginLeft: 10 }}>
                <Table className="" style={{ marginLeft: 0, marginTop: 10, marginBottom: 0 }}>
                    <DataTableHead />
                    <TableCell colSpan={columnData.length}><CircularProgress style={{ marginLeft: "50%", marginTop: 15, marginBottom: 15 }} /></TableCell>
                </Table>
            </div>
        );
    }
}

export default LoadingTable;
